import { GetItemCounts, useInfiniteClientActivity } from '@ukpostbox/client-data';
import {
	ContentBlock,
	ContentLoader,
	InfiniteLoadTrigger,
	RichEmptyState,
	Surface,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React, { useEffect, useState } from 'react';
import { ActivityFeedEventIdEnum } from '@ukpostbox/client-data/lib/Types/ClientTypes';
import { ActivityImage } from '../Images/ActivityImage';
import { ActivityEventRenewal } from './ActivityEvents/ActivityEventRenewal';
import { ActivityEventBatch } from './ActivityEvents/ActivityEventBatch';
import { ActivityEventMail } from './ActivityEvents/ActivityEventMail';
import { ActivityEventTopUp } from './ActivityEvents/ActivityEventTopUp';

function ActivityFeed() {
	const { t } = useTranslation();
	const {
		data,
		status,
		error,
		dataUpdatedAt,
		isFetchingNextPage,
		fetchNextPage,
		hasNextPage,
		isStale,
		isRefetching,
	} = useInfiniteClientActivity();

	const [itemCounts, setItemCounts] = useState<any>({ loaded: 0, total: 0 });

	useEffect(() => {
		if (data) {
			setItemCounts(GetItemCounts(data as any));
		}
	}, [dataUpdatedAt, data]);

	return (
		<>
			<h6 className='sub-heading mb-xs'>{t('activityFeed.title')}</h6>
			{status === 'pending' ? (
				<ContentLoader round childCount={10} childHeight='6.6em' />
			) : status === 'error' ? (
				<ContentBlock
					error
					title={error?.name || error?.errorRequestName}
					content={error?.message || error?.errorRequestMessage}
				/>
			) : (
				<Surface extraClass='overview-activity-container'>
					{data.pages.map((group) => {
						if (group.totalRecords === 0) {
							return (
								<RichEmptyState
									key={`activityItem${group}Empty`}
									title={t('activityFeed.noData.title')}
									description={t('activityFeed.noData.description')}
									media={<ActivityImage />}
								/>
							);
						}

						return group.data.map((item) => {
							switch (item.eventId) {
								case ActivityFeedEventIdEnum.Renewal:
									return <ActivityEventRenewal {...item} key={`activityItem-${item.eventId}`} />;
								case ActivityFeedEventIdEnum.TopUp:
									return <ActivityEventTopUp {...item} key={`activityItem-${item.eventId}`} />;
								case ActivityFeedEventIdEnum.BatchDispatched:
									return <ActivityEventBatch {...item} key={`activityItem-${item.eventId}`} />;
								case ActivityFeedEventIdEnum.LetterReceived:
								case ActivityFeedEventIdEnum.ParcelReceived:
								case ActivityFeedEventIdEnum.ContentScanned:
								default:
									return <ActivityEventMail {...item} key={`activityItem-${item.eventId}`} />;
							}
						});
					})}

					{itemCounts.total > 0 && (
						<InfiniteLoadTrigger
							loaded={itemCounts.loaded}
							totalCount={itemCounts.total}
							hasNextPage={hasNextPage}
							isStale={isStale}
							isRefetching={isRefetching}
							fetchNextPage={fetchNextPage}
							isFetchingNextPage={isFetchingNextPage}
						/>
					)}
				</Surface>
			)}
		</>
	);
}

export default ActivityFeed;
